import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import ArticleIntroduction from "./sections/ArticleIntroduction";
import ProductRankingsList from "./sections/ProductRankingsList";
import HowWeEvaluatedTheTop5 from "./sections/HowWeEvaluatedTheTop5";
import CtrRecommendsPurelywhiteDeluxe from "./sections/CtrRecommendsPurelywhiteDeluxe";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroBanner />
      <ArticleIntroduction />
      <ProductRankingsList />
      <HowWeEvaluatedTheTop5 />
      <CtrRecommendsPurelywhiteDeluxe />
      <Footer />
    </div>;
}